// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === User Guide modal ============================================== */
.ug-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: ug-fade 0.18s ease;
}

@keyframes ug-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ug-modal {
  width: 92vw;
  max-width: 1000px;
  height: 80vh;
  max-height: 720px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  border-radius: 18px;
  box-shadow: 0 30px 80px -10px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ug-pop 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes ug-pop {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}

/* Header bar */
.ug-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border-primary);
}

.ug-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.ug-title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #2663EB;
  color: #fff;
  flex-shrink: 0;
}

.ug-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: background 0.15s ease, color 0.15s ease;
}

.ug-close:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

/* Body layout: sidebar + content */
.ug-body {
  flex: 1 1;
  display: grid;
  grid-template-columns: 240px 1fr;
  min-height: 0;
}

/* Sidebar */
.ug-sidebar {
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  min-height: 0;
}

.ug-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px;
  padding: 8px 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  color: var(--text-secondary);
}

.ug-search input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 13.5px;
}

.ug-search input::placeholder {
  color: var(--text-tertiary);
}

.ug-toc {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ug-toc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 13.5px;
  font-weight: 500;
  text-align: left;
  transition: background 0.15s ease, color 0.15s ease;
}

.ug-toc-item span {
  flex: 1 1;
}

.ug-toc-arrow {
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.ug-toc-item:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.ug-toc-item:hover .ug-toc-arrow {
  opacity: 0.6;
}

.ug-toc-item.active {
  background: rgba(38, 99, 235, 0.1);
  color: #2663EB;
}

.ug-toc-item.active .ug-toc-arrow {
  opacity: 1;
  transform: translateX(2px);
}

.ug-empty {
  padding: 14px;
  font-size: 13px;
  color: var(--text-tertiary);
  text-align: center;
}

/* Content area */
.ug-content {
  overflow-y: auto;
  padding: 28px 36px 40px;
  font-size: 15px;
  line-height: 1.65;
  color: var(--text-primary);
  animation: ug-slide 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes ug-slide {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ug-content h1 {
  margin: 0 0 16px;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.ug-content h2 {
  margin: 28px 0 10px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.ug-content h3 {
  margin: 22px 0 6px;
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
}

.ug-content p {
  margin: 0 0 14px;
  color: var(--text-secondary);
}

.ug-content ul, .ug-content ol {
  margin: 0 0 16px;
  padding-left: 22px;
  color: var(--text-secondary);
}

.ug-content li {
  margin-bottom: 6px;
}

.ug-content strong {
  color: var(--text-primary);
  font-weight: 600;
}

.ug-content code {
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--bg-secondary);
  font-size: 0.9em;
  color: #2663EB;
  font-family: 'SF Mono', ui-monospace, monospace;
}

.ug-content a {
  color: #2663EB;
  text-decoration: none;
}

.ug-content a:hover {
  text-decoration: underline;
}

/* Mobile */
@media (max-width: 720px) {
  .ug-body {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
  .ug-sidebar {
    border-right: none;
    border-bottom: 1px solid var(--border-primary);
    max-height: 200px;
  }
  .ug-content {
    padding: 22px 22px 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/UserGuide.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;EACvC,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,8CAA8C;IAC9C,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* === User Guide modal ============================================== */\n.ug-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: ug-fade 0.18s ease;\n}\n\n@keyframes ug-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.ug-modal {\n  width: 92vw;\n  max-width: 1000px;\n  height: 80vh;\n  max-height: 720px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 18px;\n  box-shadow: 0 30px 80px -10px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: ug-pop 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes ug-pop {\n  from { opacity: 0; transform: scale(0.96); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n/* Header bar */\n.ug-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.ug-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.ug-title-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #2663EB;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.ug-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ug-close:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n/* Body layout: sidebar + content */\n.ug-body {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  min-height: 0;\n}\n\n/* Sidebar */\n.ug-sidebar {\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  min-height: 0;\n}\n\n.ug-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 14px;\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 10px;\n  color: var(--text-secondary);\n}\n\n.ug-search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 13.5px;\n}\n\n.ug-search input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.ug-toc {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 10px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ug-toc-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-size: 13.5px;\n  font-weight: 500;\n  text-align: left;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ug-toc-item span {\n  flex: 1;\n}\n\n.ug-toc-arrow {\n  opacity: 0;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.ug-toc-item:hover {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.ug-toc-item:hover .ug-toc-arrow {\n  opacity: 0.6;\n}\n\n.ug-toc-item.active {\n  background: rgba(38, 99, 235, 0.1);\n  color: #2663EB;\n}\n\n.ug-toc-item.active .ug-toc-arrow {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n.ug-empty {\n  padding: 14px;\n  font-size: 13px;\n  color: var(--text-tertiary);\n  text-align: center;\n}\n\n/* Content area */\n.ug-content {\n  overflow-y: auto;\n  padding: 28px 36px 40px;\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--text-primary);\n  animation: ug-slide 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes ug-slide {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.ug-content h1 {\n  margin: 0 0 16px;\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n}\n\n.ug-content h2 {\n  margin: 28px 0 10px;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.ug-content h3 {\n  margin: 22px 0 6px;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.ug-content p {\n  margin: 0 0 14px;\n  color: var(--text-secondary);\n}\n\n.ug-content ul, .ug-content ol {\n  margin: 0 0 16px;\n  padding-left: 22px;\n  color: var(--text-secondary);\n}\n\n.ug-content li {\n  margin-bottom: 6px;\n}\n\n.ug-content strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.ug-content code {\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: var(--bg-secondary);\n  font-size: 0.9em;\n  color: #2663EB;\n  font-family: 'SF Mono', ui-monospace, monospace;\n}\n\n.ug-content a {\n  color: #2663EB;\n  text-decoration: none;\n}\n\n.ug-content a:hover {\n  text-decoration: underline;\n}\n\n/* Mobile */\n@media (max-width: 720px) {\n  .ug-body {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n  }\n  .ug-sidebar {\n    border-right: none;\n    border-bottom: 1px solid var(--border-primary);\n    max-height: 200px;\n  }\n  .ug-content {\n    padding: 22px 22px 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
